import { useMemo } from 'react';

import { useCartContext } from 'features/cart/hooks/use-cart-context';
import { View } from 'react-native';

import { PromoMessageRibbon } from 'pages/loyalty/loyalty-promo-message-ribbon';
import { t } from 'state/intl/translations';

import { CartEntry } from '../cart-entry';
import { CartSectionHeader } from '../cart-section-header';

export const YourCartSection = () => {
  const { cartEntries } = useCartContext();
  const itemQuantityById = useMemo(() => {
    return cartEntries.reduce<Record<string, number>>((acc, entry) => {
      acc[entry.id] = (acc[entry.id] ?? 0) + entry.quantity;
      return acc;
    }, {});
  }, [cartEntries]);

  return (
    <View style={{ gap: 16, marginTop: 10 }}>
      <CartSectionHeader title={t('yourCart')} testID="cart-section-heading-label" />

      <PromoMessageRibbon cartEntries={cartEntries} rounded />

      {/* render cart entries in inverse order */}
      {cartEntries.map(entry => (
        <CartEntry
          key={entry.cartId}
          cartEntry={entry}
          quantityOnCart={itemQuantityById[entry.id] ?? 0}
        />
      ))}
    </View>
  );
};
